import { render, staticRenderFns } from "./HikeResource.vue?vue&type=template&id=580e08db&scoped=true"
import script from "./HikeResource.vue?vue&type=script&lang=js"
export * from "./HikeResource.vue?vue&type=script&lang=js"
import style0 from "./HikeResource.vue?vue&type=style&index=0&id=580e08db&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580e08db",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3029718028/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('580e08db')) {
      api.createRecord('580e08db', component.options)
    } else {
      api.reload('580e08db', component.options)
    }
    module.hot.accept("./HikeResource.vue?vue&type=template&id=580e08db&scoped=true", function () {
      api.rerender('580e08db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/lifehikes/hike/components/HikeResource.vue"
export default component.exports